var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":`${_vm.publicPath}img/flags/${_vm.iso}.svg`,"alt":`${_vm.alt || _vm.iso} flag`}})
}
var staticRenderFns = []

export { render, staticRenderFns }